__turbopack_context__.v({
  "iconButtonWrapper": "HeaderButton-module__nRCXVa__iconButtonWrapper",
  "regularButtonWrapper": "HeaderButton-module__nRCXVa__regularButtonWrapper",
});
